import { render, staticRenderFns } from "./AfaAltriEsamiComponent.vue?vue&type=template&id=6675e16b"
import script from "./AfaAltriEsamiComponent.vue?vue&type=script&lang=js"
export * from "./AfaAltriEsamiComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports